import React, { Component } from 'react'
import styles from './style.module.less'
import { CloseCircleFilled } from '@ant-design/icons'
import { observer } from 'mobx-react'

@observer
export default class extends Component {
  render() {
    const { mealRecord, deleteSelected, isEdit } = this.props.store
    return (
      mealRecord &&
      !!mealRecord.length && (
        <div className={styles.wrapper}>
          {mealRecord.map(item => {
            const { id, title, cover_path } = item
            return (
              <div className={styles.item} key={id}>
                {!isEdit && (
                  <CloseCircleFilled
                    className={styles.close}
                    onClick={() => {
                      deleteSelected(id)
                    }}
                  />
                )}
                <img src={`${cover_path}?imageView2/1/w/144/h/90`} />
                <div className={styles.title}>{title}</div>
              </div>
            )
          })}
        </div>
      )
    )
  }
}
